import React from 'react';

const CheckingPeriod = () => (
  <div>
    <p>Checking period here</p>
  </div>
);

export default CheckingPeriod;
